export const failureRetryButtonContainerStyle = {
    marginTop: "32px"
};